import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const MARKETPLACEPRODUCTSPAGE_LEGACY_FIELD_ORDER = [
  
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  marketplaceProductsPageDescriptor: _generatedMarketplaceProductsPageDescriptor,
  marketplaceProductsPageBlocDefinition,
  marketplaceProductsPageDashboardLayout,
  marketplaceProductsPageConfig,
  marketplaceProductsPageResolveConfig,
  marketplaceProductsPageProperties,
} = doodBlockConfig(
  {
    name: "Marketplace - All products page",
    internal_name: "Marketplace - All products page",
    url: "products",
    defaultParent: [/^Main Layout$/i],
    componentType: 'MarketplaceProductsPageComponent',
    category: 'page',
    description: "Marketplace - All products page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.marketplace-products-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
      },
      {
        key: 'footer',
        name: "pages.blocks.marketplace-products-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    // no scalar props
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["body", "footer"],
          },
        ],
      },
    ],
  })
);

export function marketplaceProductsPageDescriptor(): IBlockDescriptor;
export function marketplaceProductsPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function marketplaceProductsPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedMarketplaceProductsPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedMarketplaceProductsPageDescriptor, marketplaceProductsPageProperties, fieldOrder);
}

export {
  marketplaceProductsPageBlocDefinition,
  marketplaceProductsPageDashboardLayout,
  marketplaceProductsPageProperties,
  marketplaceProductsPageConfig,
  marketplaceProductsPageResolveConfig,
};

export type MarketplaceProductsPageConfig = typeof marketplaceProductsPageConfig;
